import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=80fc682a&scoped=true"
import script from "./TenantList.vue?vue&type=script&setup=true&lang=js"
export * from "./TenantList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TenantList.vue?vue&type=style&index=0&id=80fc682a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fc682a",
  null
  
)

export default component.exports